//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data: function () {
    return {

    }
  },

  props: {
    isMax: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    routeLink: function () {
      const user = this.$store.state?.myacuvue?.profile?.myacuvueUser || {};

      return Boolean(Object.keys(user).length > 0) ? '/profile/my-acuvue' : '/acuvue';
    }
  }

};
